<template>
  <div v-if="body_show" class="body_show">
    <public-top-tips v-show="data.uid && data.uid < 0"></public-top-tips>

    <div class="b_show">
      <img src="@a/54_top.png" alt="头" class="hb" />
      <img :src="data.poster" alt="海报" class="hb hbs" />
      <p class="b_p">长按保存图片或分享给好友</p>
      <a class="b_a" @click="reset"><span>重做一次</span></a>
      <div class="list">
        <h2>更多推荐</h2>
        <ul>
          <!-- <li class="clearfix">
            <router-link to="/my_work_ability_details_p1">
              <div class="list_l">
                <h3>你的能力能否应对变动时代？</h3>
                <h4>可迁移能力测评</h4>
              </div>
              <img src="@a/54_1.png" alt="" />
            </router-link>
          </li>
          <li class="clearfix">
            <router-link :to="'/ceping47?cid='+47">
              <div class="list_l">
                <h3>原生家庭对你职场有怎样的影响？ </h3>
                <h4>自我分化测评</h4>
              </div>
              <img src="@a/54_2.png" alt="" />
            </router-link>
          </li> -->
          <li class="clearfix">
            <a style="text-decoration: underline;" :href="adObj.link">
              <div class="list_l">
                <h3>{{adObj.title}}</h3>
                <!-- <h4>可迁移能力测评</h4> -->
              </div>
              <img v-if="adObj.image_url" :src="adObj.image_url" alt="" />
              <img v-else src="@a/advertising_03.png" alt="" />
            </a>
          </li>
        </ul>
        <!-- <router-link style="text-decoration: underline;" to="/details_active?bid=1&source=eva_54">有没有那么一刻，让你希望人生可以重来，时光可以倒流</router-link> -->
        <!-- <a style="text-decoration: underline;" href="https://appty2gguua5789.h5.xiaoeknow.com/content_page/eyJ0eXBlIjozLCJyZXNvdXJjZ
V90eXBlIjoiIiwicmVzb3VyY2VfaWQiOiIiLCJwcm9kdWN0X2lkIjoicF81Yzg1MjZhYTU1OD
RjX3B1cVdvb2NZIiwiYXBwX2lkIjoiYXBwVFkyR0d1VWE1Nzg5Iiwic2hhcmVfdXNlcl9pZCI
6InVfNWNhNDRkZjBlZDEwYV9GRTk1b3Z4djRJIiwic2hhcmVfdHlwZSI6NSwic2NlbmUiO
iJcdTUyMDZcdTRlYWIifQ">9块9，获取清晰的职业发展框架，找准优势，自我增值</a> -->
      </div>

      <public-ad-qrcode></public-ad-qrcode>
    </div>
    <!-- 关注二维码 -->
    <van-popup class="radius" :close-on-click-overlay="false" v-model="isShow">
      <div class="pop pr text-center">
        <p>你的专属报告已生成</p>
        <p>长按识别关注公众号“立即查看”</p>
        <div class="text-center">
          <img class="qr-box" :src="qrcode" alt="" />
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import {
  ceping54_report,
  ceping54_reset,
  ad
} from "@/api/measurement";
import {
  shareCon
} from "@/utils/wxconfig";

import { deepCopy } from "@/utils/tools";

import PublicAdQrcode from "@c/measurement/public-ad-qrcode";
import PublicTopTips from "@c/measurement/public-top-tips";

export default {
  data() {
      return {
        body_show: false,
        data: {},
        type_obj: {
          evaluation_id: "",
          evaluation_name: "",
          evaluation_id: ""
        },
        isShow: false,
        adObj:{}
      }
    },
    components: {
      PublicAdQrcode,
      PublicTopTips,
    },
    methods: {
      pullData() {
        this.$toast.loading({
          mask: true,
          message: "加载中..."
        });
        ceping54_report({
            token: this.$route.query.token
          })
          .then((data) => {
            this.$toast.clear();
            this.data = data;
            if (data.code != '10002') {
              document.title = data.headtitle;
              this.body_show = true;
              this.data = data;
              this.qrcode = data.qrcode;
              if (!this.data.subscribe && this.data.need_subscribe) {
                this.isShow = true;
              };
              // 给wxconfig传对象
              this.type_obj.nickname = data.nickname;
              this.type_obj.evaluation_id = data.cid;
              this.type_obj.evaluation_name = data.headtitle;
              this.type_obj.evaluation_user_id = String(data.uid);
              this.type_obj.path = this.$route.path;

              shareCon("ceping54", this, this.type_obj);

            } else {
              // 已经测评完成
              this.$router.push('/ceping54')
            }
          })
          ad().then((data) => {
              if (data.code == 10002) {
                  this.$toast(data.data.msg);
                  return false;

              }
              this.adObj = data.ad;
          })
      },
      reset() {
        ceping54_reset()
          .then((data) => {
            this.$router.push('/ceping54')
          })
      }
    },
    created() {
      this.pullData();
    }
}
</script>
<style lang="scss" scoped>
.radius {
  border-radius: 10px;
}

.pop {
  width: 8rem;
  padding-bottom: 80px;
  p:nth-child(1) {
    padding-top: 50px;
    font-size: 34px;
    line-height: 80px;
    font-weight: bold;
    color: #F57F17;
  }
  p:nth-child(2) {
    color: #333;
    font-size: 30px;
    line-height: 80px;
  }
  img {
    width: 80%;
  }
}

.body_show {
  background: url(../../../assets/54_bg.png) top center;
  background-size: cover;
  padding-bottom: 20px;
}

.b_show {
  padding: 30px
}

.top {
  background: url(../../../assets/54_top.png) no-repeat top center;
  background-size: cover;
  width: 100%;
  height: 234px;
  padding-top: 60px;
  padding-left: 20px;
  color: #333;
  font-size: 54px;
  text-align: center;
}

.top_m {
  text-align: center;
  font-size: 31px;
  color: rgba(51, 51, 51, 1);
  line-height: 45px;
}

img.hb {
  margin: 40px 0;
  width: 100%;
  vertical-align: middle;
}

img.hb.hbs {
  border: 12px solid #fff;
}

.list {
  background: rgba(255, 255, 255, 1);
  border: 4px solid rgba(51, 51, 51, 1);
  border-radius: 8px;
  padding: 40px;
  margin-top: 60px;
  h2 {
    color: #333;
    font-size: 40px;
    text-align: center;
  }
  ul li {
    margin-top: 20px;
    a {
      display: block;
      width: 100%;
      height: 100%;
      .list_l {
        float: left;
        width: 470px;
        h3 {
          color: #333;
          font-size: 31px;
        }
        h4 {
          font-size: 26px;
          color: #666;
        }
      }
      img {
        float: right;
        width: 114px;
      }
    }
  }
  a {
    font-size: 30px;
    color: #666;
    line-height: 45px;
    text-align: justify;
    margin-top: 30px;
    display: inline-block;
    cursor: pointer;
  }
}

.b_p {
  text-align: center;
  color: #333;
  margin-top: 20px;
  font-size: 31px;
}

.b_a {
  text-align: center;
  color: #333;
  display: block;
  margin: 0 auto;
  margin-top: 60px;
  width: 267px;
  height: 80px;
  border: 4px solid rgba(141, 116, 131, 1);
  position: relative;
  span {
    display: inline-block;
    width: 267px;
    height: 80px;
    background: rgba(141, 116, 131, 1);
    position: absolute;
    top: -12px;
    left: -12px;
    line-height: 80px;
    color: #fff;
    font-size: 40px;
  }
}
</style>
